// Gestos de Sina en reposo: espaciados, sutiles y solo cuando no molestan.

const MIN_GESTURE_DELAY_MS = 45_000;
const MAX_GESTURE_DELAY_MS = 90_000;

export const GESTURE_DURATION_MS = 1600;
export const TYPING_PAUSE_MS = 4000;

// Nunca se mueve con el panel abierto, un modal encima, la pestaña oculta,
// movimiento reducido en el sistema o mientras el usuario escribe.
export function canPlayIdleGesture({ isOpen, hasBlockingOverlay, documentHidden, reducedMotion, typing }) {
  return !isOpen && !hasBlockingOverlay && !documentHidden && !reducedMotion && !typing;
}

// Intervalo al azar para que el gesto no se vuelva un tic.
export function nextGestureDelay(random = Math.random) {
  return Math.round(MIN_GESTURE_DELAY_MS + random() * (MAX_GESTURE_DELAY_MS - MIN_GESTURE_DELAY_MS));
}

// El gesto marcado queda reservado para cuando hay algo urgente: el movimiento avisa algo.
export function pickIdleGesture({ hasUrgent, random = Math.random }) {
  if (hasUrgent) return 'nudge';
  const roll = random();
  if (roll < 1 / 3) return 'wave';
  if (roll < 2 / 3) return 'peek';
  return 'look';
}

// El parpadeo es frecuente y casi imperceptible: da vida sin pedir atención.
const MIN_BLINK_DELAY_MS = 3500;
const MAX_BLINK_DELAY_MS = 8000;

export const BLINK_DURATION_MS = 150;

// Los frames de ojos son de la cara en reposo: con la cara de alerta o mirando
// a los costados no se parpadea para no mezclar expresiones.
export function canBlink({ documentHidden, reducedMotion, hasUrgent, gesture }) {
  return !documentHidden && !reducedMotion && !hasUrgent && gesture !== 'look';
}

export function nextBlinkDelay(random = Math.random) {
  return Math.round(MIN_BLINK_DELAY_MS + random() * (MAX_BLINK_DELAY_MS - MIN_BLINK_DELAY_MS));
}
